export const getPaginationUrl = (
  pathname: string,
  page: number,
  locale?: string,
) => {
  const baseUrl = process.env.NEXT_PUBLIC_URL;

  const hasLocaleInPath = pathname.startsWith(`/${locale}`);
  const localePath = locale && !hasLocaleInPath ? `/${locale}` : '';

  const url = new URL(`${localePath}${pathname}`, baseUrl);

  if (page > 1) {
    url.searchParams.set('page', page.toString());
  }

  return url.toString();
};
